import DataTable from "./DataTable";

function App() {
  return (
    <div className="App">
      <DataTable />
    </div>
  );
}

export default App;
